import React from 'react';
import Button from '../../components/Button';

const fmtDate = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  } catch {
    return iso;
  }
};

const DECISION_BADGE = {
  select: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
  maybe: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  reject: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
};

/** Lists a candidate's past interview runs; click one to open its result. */
const AIInterviewHistory = ({ interviews, loading, onOpen, onBack }) => (
  <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 p-6 space-y-4">
    <div className="flex items-center justify-between">
      <h2 className="text-lg font-semibold text-slate-800 dark:text-white">Past interviews</h2>
      <button type="button" onClick={onBack} className="text-sm text-slate-500 hover:text-blue-600 transition">
        ← Back
      </button>
    </div>

    {loading && <p className="text-sm text-slate-400 py-6 text-center">Loading…</p>}

    {!loading && (!interviews || interviews.length === 0) && (
      <p className="text-sm text-slate-400 py-6 text-center">No past interviews found for these details.</p>
    )}

    <div className="space-y-2">
      {(interviews || []).map((it) => (
        <button
          key={it.interview_id}
          type="button"
          onClick={() => onOpen(it.interview_id)}
          className="w-full text-left rounded-xl border border-gray-100 dark:border-gray-800 hover:border-blue-300 dark:hover:border-blue-700 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition p-3 flex items-center justify-between gap-3"
        >
          <div className="min-w-0">
            <div className="text-sm font-medium text-slate-700 dark:text-slate-200 truncate">
              {it.role_title || 'Interview'} · {fmtDate(it.started_at)}
            </div>
            <div className="text-xs text-slate-400 mt-0.5">
              {it.finished ? `${it.questions_asked ?? 0} questions` : 'In progress'}
              {it.end_reason ? ` · ${String(it.end_reason).split('_').join(' ')}` : ''}
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {it.overall_score != null && (
              <span className="text-sm font-semibold text-slate-700 dark:text-slate-200 tabular-nums">
                {it.overall_score}
              </span>
            )}
            {it.decision && (
              <span className={`text-[11px] px-2 py-0.5 rounded-full font-medium ${DECISION_BADGE[it.decision] || ''}`}>
                {it.decision_label || it.decision}
              </span>
            )}
          </div>
        </button>
      ))}
    </div>

    <Button variant="secondary" size="md" fullWidth onClick={onBack}>
      Back to start
    </Button>
  </div>
);

export default AIInterviewHistory;
